
import common from './fr/common';
import home from './fr/home';
import airports from './fr/airports';
import profiles from './fr/profiles';
import settings from './fr/settings';
import reviews from './fr/reviews';
import inventory from './fr/inventory';
import auth from './fr/auth';
import navigation from './fr/navigation';

// Merge all translation categories into one object
const translations = {
  ...common,
  ...home,
  ...airports,
  ...profiles,
  ...settings,
  ...reviews,
  ...inventory,
  ...auth,
  ...navigation,
};

export default translations;
